import { render, staticRenderFns } from "./DialogProjectSelect.vue?vue&type=template&id=08338ad0&scoped=true"
import script from "./DialogProjectSelect.vue?vue&type=script&lang=js"
export * from "./DialogProjectSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08338ad0",
  null
  
)

export default component.exports